import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import BlogContainer from "../containers/blog/blog-grid";
import Layout from "../layouts";
import Footer from "../layouts/footer";
import Header from "../layouts/header";

const BlogPage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO
                    title="Blog | Latest Articles & Insights"
                    description="Read the latest blog articles by Muhammad Sajid on web development, cybersecurity, and software engineering. Explore insights and in-depth technical articles."
                    keywords="blog articles, read latest, tech blog, cybersecurity article, web development blog, Muhammad Sajid blog"
                />
                <div className="main-wrapper">
                    <Header />
                    <BlogContainer />
                    <Footer />
                </div>
                <ScrollToTop />
            </Layout>
        </React.Fragment>
    );
};

export default BlogPage;
